module.exports = __webpack_public_path__ + "img/partner 19.6f38316b.png";